import React from "react";

const BooleanBadge = ({ value, trueLabel, falseLabel }) => {
  const tone = value ? "success" : "danger";

  return (
    <span className={`badge badge--boolean badge--${tone}`}>
      {value ? trueLabel : falseLabel}
    </span>
  );
};

const TruFalseBadge = ({ getValue }) => {
  const value = getValue();
  return <BooleanBadge value={value} trueLabel="TRUE" falseLabel="FALSE" />;
};

const OpenCloseBadge = ({ getValue }) => {
  const value = getValue();
  return <BooleanBadge value={value} trueLabel="Open" falseLabel="Close" />;
};

const YesNoBadge = ({ getValue }) => {
  const value = getValue();
  return <BooleanBadge value={value} trueLabel="Yes" falseLabel="No" />;
};

const ActiveInactiveBadge = ({ getValue }) => {
  const value = getValue();
  return (
    <BooleanBadge value={value} trueLabel="Active" falseLabel="Inactive" />
  );
};

const SucceededFailedBadge = ({ getValue }) => {
  const value = getValue();
  return (
    <BooleanBadge value={value} trueLabel="Succeeded" falseLabel="Failed" />
  );
};

const StaticBadge = ({ getValue }) => {
  return (
    <span className={`badge bg-primary-subtle text-primary`}>{getValue()}</span>
  );
};

export {
  TruFalseBadge,
  OpenCloseBadge,
  StaticBadge,
  YesNoBadge,
  ActiveInactiveBadge,
  SucceededFailedBadge,
};
